import { SmileySadIcon } from "@phosphor-icons/react/dist/csr/SmileySad";
import { BaseIntegration } from "./BaseIntegration";

class UnknownIntegration extends BaseIntegration {
  displayName() {
    return (
      <span>
        Unknown <SmileySadIcon />
      </span>
    );
  }

  sortName() {
    return "Unknown";
  }
}

const UnknownIntegrationEditor = () => {
  return (
    <div>
      <p>This integration cannot be modified.</p>
    </div>
  );
};

const UNKNOWN_INTEGRATION = {
  integrationType: "unknown",
  title: "Unknown",
  short_title: "Unknown",
  description: (
    <p>
      Unknown <SmileySadIcon />
    </p>
  ),
  image: "",
  oauth: false,
  clazz: UnknownIntegration,
  editor: UnknownIntegrationEditor,
};

export { UNKNOWN_INTEGRATION };
